/* unplugin-vue-components disabled */import script from "./Web3dViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./Web3dViewer.vue?vue&type=script&setup=true&lang=ts"

import "./Web3dViewer.vue?vue&type=style&index=0&id=20073c1a&scoped=true&lang=scss"
import "./Web3dViewer.vue?vue&type=style&index=1&id=20073c1a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20073c1a"]])

export default __exports__